<main-content-holder>
  <h2 class="center-align" i18n="Password Reset Confirm|Password Reset Confirm title@@password-reset-confirm-title">
    Confirm Password Change</h2>

  <div fxLayout="row" fxLayout.lt-md="column" class="full-width">
    <form [formGroup]="resetConfirmForm" class="center-align" autocomplete="off">
      <form-input [control]="emailField"
                  label="Email"
                  i18n-label="Sign In|Email input label@@sign-in-email-label"
                  placeholder="Your email..."
                  i18n-placeholder="Sign In|Email input placeholder@@sign-in-email-placeholder"
                  autocomplete="email"
                  type="email"
                  [minLength]="5" [maxLength]="128"></form-input>

      <form-input [control]="codeField"
                  label="Confirmation Code"
                  i18n-label="Password Reset Confirm|Confirmation Code input label@@password-reset-confirm-code-label"
                  placeholder="e.g. 000000"
                  i18n-placeholder="Password Reset Confirm|Confirmation Code input placeholder@@password-reset-confirm-code-placeholder"
                  [type]="forcedCode ? 'text' : 'number'"
                  [minLength]="6" [maxLength]="forcedCode ? 10 : 6"></form-input>

      <form-input [control]="passwordField"
                  label="Password"
                  i18n-label="Sign Up|Password input label@@sign-up-password-label"
                  placeholder="New password..."
                  i18n-placeholder="Change Password|New password input placeholder@@change-password-new-password-placeholder"
                  type="password"
                  suffixButton="visibility"
                  suffixButtonAlt="visibility_off"></form-input>
      <form-input [control]="confirmPassField"
                  [formGroup]="resetConfirmForm"
                  [errorStateMatcher]="matcher"
                  label="Confirm Password"
                  i18n-label="Change Password|Confirm password input label@@change-password-confirm-password-label"
                  placeholder="Confirm password..."
                  i18n-placeholder="Change Password|Confirm password input placeholder@@change-password-confirm-password-placeholder"
                  type="password"
                  suffixButton="visibility"
                  suffixButtonAlt="visibility_off"></form-input>

      <app-button *ngIf="!inProgress"
                  label="Change Password"
                  i18n-label="Password Reset Confirm|Change button label@@password-reset-change-button-label"
                  class="cta-btn center"
                  width="205px"
                  [disabled]="shouldDisableSubmit()"
                  (clicked)="resetConfirm()"></app-button>

      <span *ngIf="inProgress" class="progress-spinner">
        <mat-spinner color="primary" class="center" [diameter]="40"></mat-spinner>
      </span>

      <div class="footer center-align">
        <ng-container i18n="Password Reset|Back to Sign In prompt@@password-reset-back-to-sign-in-prompt">Back to
        </ng-container>
        <app-link [routerLink]="signInUrl"
                  label="Sign In"
                  i18n-label="Password Reset|Back to Sign In link label@@password-reset-back-to-sign-in-link-label"
                  class="link"></app-link>
      </div>
    </form>

    <div class="language-switch">
      <language-switch theme="dark"></language-switch>
    </div>
  </div>
</main-content-holder>
